import API from 'types/api';
import { takeLatest, take, takeEvery } from 'redux-saga/effects';

export default function* epgSaga() {
  yield takeLatest(API.GET_EPG_TIME, onRelatedAction);
  yield takeLatest(API.GET_EPG_CURRENT, onRelatedAction);
  yield takeEvery(API.GET_EPG, onRelatedAction);
  yield takeLatest(API.GET_CHANNELS, onRelatedAction);
  yield takeLatest(API.GET_STREAM_VIRTUAL, onRelatedAction);
  yield takeLatest(API.GET_STREAM_EXTERNAL, onRelatedAction);
}

function* onRelatedAction({ type, payload }) {
  const action = yield take([`${type}_SUCCESS`, `${type}_ERROR`]);
  if (action.type.includes('SUCCESS')) {
    payload.onSuccess(action.payload);
  } else if (action.type.includes('ERROR')) {
    payload.onError(action.payload);
  }
}
